import React from "react";

export const Guide = () => {
 return (
  <div style={{ width: "480px", margin: "28px auto" }}>
   <p>
    <b>HOW TO PLAY:</b> Use your <b>arrow</b> or <b>A W S D</b> keys or <b>swipe</b> if on the phone to move the tiles.
    Tiles with the same number <b>merge into one</b> when they touch. Add them up to reach <b>2048!</b>
   </p>
  </div>
 );
};
